import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck, Sparkles, Zap } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 px-6 bg-slate-950 relative overflow-hidden" data-id="element-192">
      {/* Glow effect behind card */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-amber-600/10 rounded-full blur-[100px]" data-id="element-193" />

      <div className="max-w-lg mx-auto relative z-10" data-id="element-194">
        <FadeIn data-id="element-195">
          <div className="bg-slate-900 border border-amber-500/30 rounded-3xl p-8 md:p-12 text-center shadow-2xl shadow-amber-900/20 relative overflow-hidden" data-id="element-196">
            {/* Special offer badge */}
            <div className="absolute -top-1 -right-1 bg-gradient-to-r from-amber-500 to-orange-500 text-slate-950 text-xs font-bold px-4 py-2 rounded-bl-2xl rounded-tr-3xl flex items-center gap-1.5 shadow-lg" data-id="element-197">
              <Zap size={14} className="fill-current" data-id="element-198" />
              77% OFF
            </div>

            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 text-amber-400 text-sm font-semibold px-4 py-2 rounded-full mb-6" data-id="element-199">
              <Sparkles size={14} data-id="element-200" />
              OFERTA ESPECIAL POR TIEMPO LIMITADO
            </div>

            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-201">
              CLUB DE LAS 3AM
            </h3>
            <p className="text-slate-400 mb-6" data-id="element-202">Mini Kit de Rescate</p>

            {/* Price with dramatic discount */}
            <div className="mb-6" data-id="element-203">
              <div className="flex items-center justify-center gap-2 mb-3" data-id="element-204">
                <span className="text-xl text-slate-500 line-through decoration-red-500/70 decoration-2" data-id="element-205">
                  $27.55
                </span>
                <span className="bg-red-500/20 text-red-400 text-xs font-bold px-2 py-1 rounded" data-id="element-206">
                  -77%
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-1" data-id="element-207">
                <span className="text-6xl font-bold text-white" data-id="element-208">$6</span>
                <span className="text-3xl font-bold text-white" data-id="element-209">.39</span>
                <span className="text-slate-500 text-lg ml-1" data-id="element-210">USD</span>
              </div>
            </div>

            <div className="bg-gradient-to-r from-green-500/10 via-green-500/20 to-green-500/10 border border-green-500/30 text-green-400 text-sm font-medium px-4 py-2 rounded-xl mb-8" data-id="element-211">
              🎉 ¡Ahorras $21.16 hoy!
            </div>

            <p className="text-slate-300 mb-8 text-sm" data-id="element-212">
              Un gasto pequeño comparado con lo que cuesta una semana rota, un
              día destruido, o esa sensación de estar perdiendo el control.
            </p>

            <Button fullWidth className="mb-6 text-lg py-5" data-id="element-213">
              Descargar el Kit Ahora — $6.39
            </Button>

            <div className="flex items-center justify-center gap-2 text-slate-500 text-sm" data-id="element-214">
              <ShieldCheck size={16} data-id="element-215" />
              <span data-id="element-216">Pago seguro y acceso inmediato</span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={200} data-id="element-217">
          <div className="mt-16 text-center space-y-6" data-id="element-218">
            <p className="text-xl text-slate-300 font-medium" data-id="element-219">
              Si el "Club de las 3AM" es tu realidad… <br data-id="element-220" />
              no necesitas más fuerza de voluntad.
            </p>
            <p className="text-amber-400 text-lg" data-id="element-221">Necesitas un protocolo.</p>
          </div>
        </FadeIn>
      </div>
    </section>;
}